import React from 'react';
import { Application } from '../../api/application';
import { goToApplication } from '../../utils/applications';
import { Container, Grid } from '@material-ui/core';

import Information from '../Information/Information';
import Resend from '../Verification/Resend';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from '../../Providers/AuthenticationProvider';

interface ConfirmationContentProps {
    classes: any;
    success?: boolean;
    message: string;
    application: Application;
    usedOnceHeader?: string;
    // @ts-ignore
    usedOnceBody?: any | string;
    // @ts-ignore
    usedOnceButton?: any | string;
    blockedHeader?: string;
    // @ts-ignore
    blockedBody?: any | string;
    // @ts-ignore
    blockedButton?: any | string;
    expiredHeader?: string;
    // @ts-ignore
    expiredBody?: any | string;
    // @ts-ignore
    expiredButton?: any | string;
    mfaResetHeader?: string;
    // @ts-ignore
    mfaResetBody?: any | string;
    // @ts-ignore
    mfaResetButton?: any | string;
    showResendIfSuccessFalse?: boolean
    resendPassword?: Function,
    iconURL?: string
}

const ConfirmationContent: React.FC<ConfirmationContentProps> = ({ classes, success, message, application, usedOnceHeader, usedOnceBody, usedOnceButton, blockedHeader, blockedBody, blockedButton, expiredHeader, expiredBody, expiredButton, mfaResetHeader, mfaResetBody, mfaResetButton, showResendIfSuccessFalse, resendPassword, iconURL }) => {

    const { t } = useTranslation();
    const { logoutWithRedirect } = useAuthentication();

    const logoutGoToLogin = () => {
        sessionStorage.setItem("redirectAfterLogout", `/initiate-login`);
        logoutWithRedirect();
    }

    const goToApp = () => {
        goToApplication(application);
    }

    return (
        <Container className={classes.containerRoot}>
            <Container maxWidth="md" className={`${classes.outerContainer} ${classes.relativeContainer}`}>
                <Grid container className={classes.contentContainerRoot}>
                    <Grid item xs={12}>
                        {!success && message === 'this url can be used only once' && !showResendIfSuccessFalse && (
                            <Information
                                handleButtonClick={() => goToApplication(application)}
                                headerText={usedOnceHeader}
                                bodyText={usedOnceBody}
                                buttonText={usedOnceButton}
                                dip_app_type={application.dip_app_type}
                            />
                        )}
                        {!success && message === 'this url can be used only once' && showResendIfSuccessFalse && (
                            <Resend
                                callback={() => resendPassword && resendPassword()}
                                headerText={usedOnceHeader}
                                bodyText={usedOnceBody}
                                buttonText={usedOnceButton}
                                links={application.dip_app_type !== 'client_app' ? [
                                    {
                                        linkText:`${parse(t('email_verification.congratulations.button', { application: (application.translations?.name || application.name || ''), url: application.url }))}`,
                                        onClick: () => goToApplication(application)
                                    }
                                ] : []}
                                type="passwordReset"
                                showPasswordField={false}
                            />
                        )}
                        {!success && message === 'access expired.' && showResendIfSuccessFalse && (
                            <Resend
                                callback={() => resendPassword && resendPassword()}
                                headerText={expiredHeader}
                                bodyText={expiredBody}
                                buttonText={expiredButton}
                                type="passwordReset"
                                showPasswordField={false}
                            />
                        )}
                        {message === 'mfa reset confirmation' && (
                            <Information
                                handleButtonClick={() => logoutGoToLogin()}
                                headerText={mfaResetHeader}
                                bodyText={mfaResetBody}
                                buttonText={mfaResetButton}
                                iconURL={iconURL}
                                dip_app_type={application.dip_app_type}
                            />
                        )}
                        {success && (
                            <Information
                                handleButtonClick={goToApp}
                                headerText={blockedHeader}
                                bodyText={blockedBody}
                                buttonText={blockedButton}
                                dip_app_type={application.dip_app_type}
                            />
                        )}

                    </Grid>
                </Grid>
            </Container>
        </Container>
    );
}

export default ConfirmationContent
